import { getUserObject, assortments } from "utils/relewise";

function getPopularProductCategoryObject(options) {
  return {
    SinceMinutesAgo: 10080,
    Weights: {
      CategoryViews: 10,
      ProductViews: 1,
      ProductPurchases: 0,
    },
    Settings: {
      NumberOfRecommendations: 2,
      AllowFillIfNecessaryToReachNumberOfRecommendations: true,
      AllowReplacingOfRecentlyShownRecommendations: true,
      PrioritizeDiversityBetweenRequests: false,
      SelectedProductCategoryProperties: {
        DisplayName: true,
        DataKeys: ["Handle"],
      },
    },
    Language: {
      Value: window.mosmosh.shop_local.iso,
    },
    User: getUserObject(),
    displayedAtLocationType: "Category Page",
    currency: {
      Value: window.mosmosh.currency.iso,
    },
    Filters: {
      Items: [
        {
          $type: "Relewise.Client.Requests.Filters.ProductCategoryAssortmentFilter, Relewise.Client",
          Assortments: [assortments[window.mosmosh.shop_code]],
          TypeName: "ProductCategoryAssortmentFilter",
        },
        {
          $type: "Relewise.Client.Requests.Filters.ProductCategoryDataFilter, Relewise.Client",
          Key: "Handle",
          MustMatchAllConditions: true,
          Conditions: {
            Items: [
              {
                $type: "Relewise.Client.Requests.Conditions.EqualsCondition, Relewise.Client",
                Value: {
                  Value: "api",
                },
                TypeName: "EqualsCondition",
                Negated: true,
              },
            ],
          },
          TypeName: "ProductCategoryDataFilter",
        },
        {
          $type: "Relewise.Client.Requests.Filters.ProductCategoryDataFilter, Relewise.Client",
          Key: "Vendor",
          MustMatchAllConditions: true,
          Conditions: {
            Items: [
              {
                $type: "Relewise.Client.Requests.Conditions.EqualsCondition, Relewise.Client",
                Value: {
                  Value: "Gallery",
                },
                TypeName: "EqualsCondition",
                Negated: options.currentUniverse !== "Gallery",
              },
            ],
          },
          TypeName: "ProductCategoryDataFilter",
        },
      ],
    },
  };
}

export default getPopularProductCategoryObject;
